import pt from 'vuetify/lib/locale/pt'

export default {
    ...pt,
    add: 'Adicionar',
    addAlternateEmail: 'Adicionar e-mail alternativo',
    addAlternateEmailxs: 'E-mail alternativo',
    addAlternatePhone: 'Adicionar telefone alternativo',
    addAlternatePhonexs: 'Tel alternativo',
    cancel: 'Cancelar',
    change: 'Alterar',
    changePassword: 'Alterar senha',
    chooseRegisteredPhone: 'Ou escolha um telefone cadastrado',
    countryCode: 'Código do país',
    createAccount: 'Criar conta',
    emailLoginLabel: 'E-mail',
    extension: 'Ramal',
    forgotPass: 'Recuperar a senha',
    forgotPassBtn: 'Enviar',
    forgotPassLink: 'Esqueceu a senha?',
    help: 'Ajuda',
    lastUpdate: 'Última atualização',
    logout: 'Sair',
    name: 'Nome',
    newPassword: 'Nova senha',
    oldPassword: 'Senha antiga',
    passLoginLabel: 'Senha',
    password: 'Senha',
    passwordExpirationDate: 'Data de expiração da senha',
    phone: 'Telefone',
    primaryEmail: 'E-mail principal',
    primaryPhone: 'Telefone principal',
    register: 'Registrar',
    remove: 'Remover',
    returnToLogin: 'Retornar para login',
    save: 'Salvar',
    saveChanges: 'Salvar alterações',
    selectLocale: 'Selecionar o idioma',
    signIn: 'Login',
    signInBtn: 'Entrar',
    smsCellphone: 'Preencha um celular para receber SMS',
    smsCellphonexs: 'Celular para SMS',
    userInformation: 'Informações do usuário',
    userInformationxs: 'Perfil',
}
